module.exports = __webpack_public_path__ + "img/bg7-5.76441bf2.png";